import React, { Fragment, useContext, useEffect, useState } from "react";
import ReceiptMod from "../../Reservation/ReceiptMod";
import { AppContext } from "../../../components/AppProvider";
import { PostApi1970 } from "../../../modules/network/padoPost";

const ReceiptModify = (props) => {
  const { userinfo, phonecfg, cfg } = useContext(AppContext);
  const [nftfData, setNftfData] = useState();
  const [modifyMode, setModifyMode] = useState(false);

  const getNftfReceiptData = () => {
    PostApi1970(userinfo, cfg, phonecfg, props.match.params.seqNo)
      .then((res) => {
        if (res.resultMsg === "Success") {
          setNftfData(res.result);
          setModifyMode(true);
        }
      })
      .catch((err) => {
        console.log("err :: ", err);
      });
  };

  useEffect(() => {
    getNftfReceiptData();
  }, []);

  return (
    <Fragment>
      {modifyMode && (
        <ReceiptMod
          // setModifyMode={setModifyMode}
          pharmInfo={{
            phKey: nftfData.phKey,
            pharmName: nftfData.pharmName,
            pharmFaxNum: nftfData.pharmFaxNum,
            pharmTelNo: nftfData.pharmTelNo,
            appID: props.match.params.seqNo,
          }}
        />
      )}
    </Fragment>
  );
};

export default ReceiptModify;
